import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const PriorityTasksCard: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Приоритетные задачи</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
          <h4 className="font-medium text-red-800">Критично</h4>
          <p className="text-sm text-red-700">Исправить TypeScript ошибки в categoryService.ts</p>
        </div>
        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <h4 className="font-medium text-yellow-800">Важно</h4>
          <p className="text-sm text-yellow-700">Настроить SMTP для отправки email уведомлений</p>
        </div>
        <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <h4 className="font-medium text-blue-800">Улучшения</h4>
          <p className="text-sm text-blue-700">Добавить больше автоматических тестов для критических компонентов</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default PriorityTasksCard;
